import React from 'react';

import styled from '@emotion/styled';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

import ErrorIcon from 'assets/alerts/error-icon-white.svg';
import InfoIcon from 'assets/alerts/info-icon-white.svg';
import SuccessIcon from 'assets/alerts/success-icon-white.svg';
import WarningIcon from 'assets/alerts/warning-icon-white.svg';

const AlertIcon = styled('img')({ marginTop: '2px' });

const AlertIconsMapping = {
  info: <AlertIcon src={InfoIcon} />,
  error: <AlertIcon src={ErrorIcon} />,
  success: <AlertIcon src={SuccessIcon} />,
  warning: <AlertIcon src={WarningIcon} />,
};

const StyledAlert = styled(MuiAlert)({
  '&.MuiAlert-root': {
    padding: '0 8px 0 0',
    margin: '0',
    color: '#F8F8F8',
  },
  '&.MuiAlert-filledSuccess': {
    backgroundColor: '#58B947',
  },
  '&.MuiAlert-filledInfo': {
    backgroundColor: 'var(--du-color-primary)',
  },
  '&.MuiAlert-filledWarning': {
    backgroundColor: '#FF9E19',
  },
  '& MuiAlert-filledError': {
    backgroundColor: '#E4001C',
  },
  '& .MuiAlert-icon': { padding: '0', opacity: '1', margin: '0' },
  '&.MuiAlert-message': {
    font: 'normal normal 600 16px/16px Diodrum',
    letterSpacing: '0px',
    color: '#F8F8F8',
  },
});

const DupontAlert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <StyledAlert elevation={0} ref={ref} variant='filled' {...props} iconMapping={AlertIconsMapping} />;
});

export default DupontAlert;
